import { convertNullMembersToUndefined, toHttpParams, createNamedApi, createServiceApi, serviceTypes, ensureArray, combineEffectsWithProviders } from '@essent/common';
export { CaseStatus, EnergyType, ProductDuration } from '@essent/common';
import * as i1 from '@angular/common/http';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1$1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

/**
 * @ignore
 */
const API = new InjectionToken('api-address');

class AddressCheckRequestMapper {
    map(params) {
        const postcode = params.postcode.replace(' ', '').toUpperCase();
        const { houseNumber } = params;
        return {
            house_number: houseNumber,
            postcode
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckRequestMapper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckRequestMapper }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckRequestMapper, decorators: [{
            type: Injectable
        }] });

/**
 * Maps [AddressCheckResponse]{@link AddressCheckResponse#source} to [AddressCheckResult]{@link AddressCheckResult#source}
 *
 * # <span style="color:red">**NOT EXPOSED BY PUBLIC_API!**</span>
 */
class AddressCheckResponseMapper {
    map(response) {
        return convertNullMembersToUndefined(response.address);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckResponseMapper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckResponseMapper }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCheckResponseMapper, decorators: [{
            type: Injectable
        }] });

class GetAddressCheckService {
    constructor(apiUrl, httpClient, addressResponseMapper, addressRequestMapper) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.addressResponseMapper = addressResponseMapper;
        this.addressRequestMapper = addressRequestMapper;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/util/address/check/v${this.apiVersion}`;
    }
    call$(params) {
        const queryParams = this.addressRequestMapper.map(params);
        return this.httpClient
            .get(this.endpoint, {
            /**
             * TODO: Track issue: https://github.com/Microsoft/TypeScript/issues/15300
             */
            params: toHttpParams(queryParams)
        })
            .pipe(map(response => this.addressResponseMapper.map(response)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetAddressCheckService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }, { token: AddressCheckResponseMapper }, { token: AddressCheckRequestMapper }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetAddressCheckService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetAddressCheckService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }, { type: AddressCheckResponseMapper }, { type: AddressCheckRequestMapper }] });

const getAddressCheckApi = createNamedApi('[AddressCheckState] Get address check', GetAddressCheckService);

const { getAddressCheckActions, getAddressCheck, getAddressCheckSuccess, getAddressCheckError, getAddressCheckClear } = getAddressCheckApi;

const apiVersion$1 = '4';
const getContractsApi = createServiceApi('[AddressState] Get contracts', 'get', serviceTypes(), {
    getUrl: `/contracting/contracts/v${apiVersion$1}`,
    version: apiVersion$1,
    defaultHeaders: {
        Accept: 'application/json'
    },
    getParams: payload => payload
});

/**
 * Maps [GetInstallationAddressesPayload]{@link GetInstallationAddressesPayload#source}
 * to [InstallationAddressesQueryParams]{@link InstallationAddressesQueryParams#source}
 *
 * # <span style="color:red">**NOT EXPOSED BY PUBLIC_API!**</span>
 */
class InstallationAddressesRequestMapper {
    map(params) {
        const postcode = params.postcode.replace(' ', '').toUpperCase();
        const { houseNumber } = params;
        return {
            house_number: houseNumber,
            postcode
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesRequestMapper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesRequestMapper }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesRequestMapper, decorators: [{
            type: Injectable
        }] });

/**
 * Maps [InstallationAddressesResponse]{@link InstallationAddressesResponse#source}
 * to a collection of [InstallationAddress]{@link InstallationAddress#source}
 *
 * # <span style="color:red">**NOT EXPOSED BY PUBLIC_API!**</span>
 */
class InstallationAddressesResponseMapper {
    map(response) {
        const addresses = ensureArray(response.addresses.address).map(convertNullMembersToUndefined);
        return addresses.map(address => ({
            postcode: address.postcode,
            houseNumber: address.house_number,
            houseNumberExtension: address.house_number_extension,
            street: address.street,
            city: address.city,
            country: address.country
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesResponseMapper, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesResponseMapper }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressesResponseMapper, decorators: [{
            type: Injectable
        }] });

class GetInstallationAddressesService {
    constructor(apiUrl, httpClient, addressesResponseMapper, addressesRequestMapper) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.addressesResponseMapper = addressesResponseMapper;
        this.addressesRequestMapper = addressesRequestMapper;
        this.apiVersion = '2';
        this.endpoint = `${this.apiUrl || ''}/accounts/findInstallationAddresses/v${this.apiVersion}`;
    }
    /**
     * Performs a GET request with query params to `/accounts/findInstallationAddresses/v[apiVersion]`
     */
    call$(params) {
        const queryParams = this.addressesRequestMapper.map(params);
        return this.httpClient
            .get(this.endpoint, {
            /**
             * TODO: Track issue: https://github.com/Microsoft/TypeScript/issues/15300
             */
            params: toHttpParams(queryParams)
        })
            .pipe(map(response => this.addressesResponseMapper.map(response)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetInstallationAddressesService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }, { token: InstallationAddressesResponseMapper }, { token: InstallationAddressesRequestMapper }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetInstallationAddressesService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetInstallationAddressesService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }, { type: InstallationAddressesResponseMapper }, { type: InstallationAddressesRequestMapper }] });

const getInstallationAddressesApi = createNamedApi('[AddressState] Get installation addresses', GetInstallationAddressesService);

const apiVersion = '3';
const getInstallationDetailsApi = createServiceApi('[AddressState] Get installation details', 'get', serviceTypes(), {
    getUrl: `/contracting/contracts/installations/v${apiVersion}`,
    version: apiVersion,
    defaultHeaders: {
        Accept: 'application/json'
    },
    getParams: payload => payload
});

/* eslint-disable max-classes-per-file */
const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getAddressCheckApi, getInstallationAddressesApi, getInstallationDetailsApi, getContractsApi);
const EXTRA_PROVIDERS = [
    AddressCheckResponseMapper,
    AddressCheckRequestMapper,
    InstallationAddressesResponseMapper,
    InstallationAddressesRequestMapper
];
/**
 * Module containing all providers.
 *
 * ### Example usage
 *
 * #### Normal
 * ```typescript
 * providers: [
 *     AddressCoreModule,
 *     ...
 * ]
 * ```
 *
 * #### Custom API
 *
 * ```typescript
 * providers: [
 *     AddressCoreModule.forRoot({
 *         api: 'https://my-api.com'
 *     }),
 *     ...
 * ]
 * ```
 */
class AddressCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AddressCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: AddressCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCoreModule, deps: [{ token: AddressCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: AddressCoreModule, imports: [i1$1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCoreModule, providers: [...EXTRA_PROVIDERS, ...PROVIDERS], imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: AddressCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: [...EXTRA_PROVIDERS, ...PROVIDERS]
                }]
        }], ctorParameters: () => [{ type: AddressCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getContractsActions, getContracts, getContractsSuccess, getContractsError, getContractsClear } = getContractsApi;

var ContractStatus;
(function (ContractStatus) {
    ContractStatus["PENDING"] = "pending_contract";
    ContractStatus["WAITING_FOR_DELIVERY"] = "waiting_for_delivery";
    ContractStatus["ACTIVE"] = "active_contract";
    ContractStatus["ENDED"] = "ended_contract";
    ContractStatus["FUTURE"] = "future_contract";
})(ContractStatus || (ContractStatus = {}));

const { getInstallationAddressesActions, getInstallationAddresses, getInstallationAddressesSuccess, getInstallationAddressesError, getInstallationAddressesClear } = getInstallationAddressesApi;

const { getInstallationDetailsActions, getInstallationDetails, getInstallationDetailsSuccess, getInstallationDetailsError, getInstallationDetailsClear } = getInstallationDetailsApi;

/**
 * Generated bundle index. Do not edit.
 */

export { API, AddressCoreModule, ContractStatus, getAddressCheck, getAddressCheckActions, getAddressCheckClear, getAddressCheckError, getAddressCheckSuccess, getContracts, getContractsActions, getContractsClear, getContractsError, getContractsSuccess, getInstallationAddresses, getInstallationAddressesActions, getInstallationAddressesClear, getInstallationAddressesError, getInstallationAddressesSuccess, getInstallationDetails, getInstallationDetailsActions, getInstallationDetailsClear, getInstallationDetailsError, getInstallationDetailsSuccess };
